import { contentFetch } from "../contentClient.js";

// ============= Projects API (v2) =============

const BASE = "/api/v2/projects";

export async function getProjects({ search, systemName, page = 1, pageSize } = {}, init) {
    const params = { page };
    if (pageSize) params.pageSize = pageSize;
    if (search?.trim()) params["filter.name:contains"] = search.trim();
    if (systemName) params["filter.systemName"] = systemName;
    return contentFetch(BASE, { params, ...(init || {}) });
}

export async function getProjectById(projectId, init) {
    return contentFetch(`${BASE}/${projectId}`, init);
}

export async function createProject(payload, init) {
    // payload: { systemName, name, description? }
    return contentFetch(BASE, {
        method: "POST",
        body: payload,
        ...(init || {}),
    });
}

export async function patchProject(projectId, payload, init) {
    // payload: { name?, description? }
    return contentFetch(`${BASE}/${projectId}`, {
        method: "PATCH",
        body: payload,
        ...(init || {}),
    });
}

export async function renameProjectSystemName(projectId, newSystemName, init) {
    return contentFetch(`${BASE}/${projectId}:rename`, {
        method: "POST",
        body: { newSystemName },
        ...(init || {}),
    });
}

export async function deleteProject(projectId, init) {
    return contentFetch(`${BASE}/${projectId}`, {
        method: "DELETE",
        ...(init || {}),
    });
}
